var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect3, _path10, _g, _rect4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect5, _path19, _rect6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect7, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect8, _path36, _path37, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBannerPattern = function SvgBannerPattern(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 360,
    viewBox: "0 0 600 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(120 60)",
    fill: "#54C2E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.149 97.8177C176.973 102.658 175.297 108.846 170.405 111.641C165.514 114.435 159.259 112.777 156.434 107.937C153.61 103.097 155.286 96.9082 160.178 94.1139C165.069 91.3196 171.324 92.9779 174.149 97.8177Z",
    fill: "#F4EADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.372 97.8177C123.548 102.658 125.224 108.846 130.115 111.641C135.007 114.435 141.262 112.777 144.086 107.937C146.91 103.097 145.234 96.9082 140.343 94.1139C135.451 91.3196 129.196 92.9779 126.372 97.8177Z",
    fill: "#F4EADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.117 72.0619C161.942 76.9017 160.266 83.0905 155.374 85.8848C150.482 88.6791 144.227 87.0208 141.403 82.181C138.579 77.341 140.255 71.1523 145.147 68.358C150.038 65.5638 156.293 67.222 159.117 72.0619Z",
    fill: "#F4EADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(60 60)",
    fill: "#FF442A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8226 64.0013L82.7812 82.4121H97.3653L89.8226 64.0013Z",
    fill: "#F4EADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.895 89.3652L97.6328 82.267V96.9688L115.895 89.3652Z",
    fill: "#F4EADA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 89.3652L82.2623 82.267V96.9688L64 89.3652Z",
    fill: "#F4EADA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.244 71.5696L90.3516 79.5686L100.664 89.9648L108.244 71.5696Z",
    fill: "#F4EADA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4531 71.5696L89.3455 79.5686L79.0331 89.9648L71.4531 71.5696Z",
    fill: "#F4EADA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8708 116.002L96.9121 97.5912H82.3281L89.8708 116.002Z",
    fill: "#F4EADA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4531 108.439L89.3455 100.44L79.0331 90.0442L71.4531 108.439Z",
    fill: "#F4EADA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.244 108.439L90.3516 100.44L100.664 90.0442L108.244 108.439Z",
    fill: "#F4EADA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(60 120)",
    fill: "#7D4C8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3648 153.461C95.3648 154.724 94.3173 155.749 93.025 155.749H85.9749C84.6828 155.749 83.6351 154.724 83.6351 153.461V146.539C83.6351 145.275 84.6828 144.251 85.9749 144.251H93.025C94.3173 144.251 95.3648 145.275 95.3648 146.539V153.461ZM104.961 140.284V140.272H101.43C100.366 140.272 99.503 139.429 99.503 138.388V136.41H99.4733C99.4739 136.37 99.4765 136.331 99.4765 136.291C99.4765 131.16 95.2226 127 89.975 127C84.7275 127 80.4736 131.16 80.4736 136.291C80.4736 136.336 80.4766 136.381 80.4771 136.427V138.388C80.4771 139.429 79.6145 140.272 78.5504 140.272H74.6206C69.3815 140.272 65.0389 144.37 65.0003 149.493C64.9611 154.656 69.2298 158.854 74.5013 158.854V158.876H78.5504C79.6145 158.876 80.4771 159.72 80.4771 160.76V163.573C80.4766 163.619 80.4736 163.663 80.4736 163.709C80.4736 168.84 84.7275 173 89.975 173C95.2042 173 99.4455 168.869 99.4752 163.763H99.503V160.76C99.503 159.72 100.366 158.876 101.43 158.876H104.961V158.842C109.994 158.606 114 154.542 114 149.563C114 144.584 109.994 140.52 104.961 140.284Z",
    fill: "#F4EADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#banner-pattern_svg__clip0_3038_43545)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "matrix(0 -1 1 0 360 360)",
    fill: "#7D4C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.592 239L403 278H436L419.592 239Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.592 279L403 320H436L419.592 279Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.592 320L403 360H436L419.592 320Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 360H444V239H440V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 360H452V239H448V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 360H459V239H455V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 360H468V239H464V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 360H476V239H472V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 360H367V239H363V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 360H375V239H371V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 360H384V239H379V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 360H392V239H388V360Z",
    fill: "#F4EAD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 360H399V239H395V360Z",
    fill: "#F4EAD9"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "translate(120 120)",
    fill: "#E69408"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.188 180.865L230.681 165.78V195.781L195.188 180.865Z",
    fill: "#54220E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.876 165.775L166.406 129H195.185L180.876 165.775Z",
    fill: "#54220E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.715 195.78L195.185 231.588H166.406L180.715 195.78Z",
    fill: "#54220E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.412 180.697L129 195.781V165.78L166.412 180.697Z",
    fill: "#54220E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.391 190.939L226.843 206.24L205.627 227.715L190.391 190.939Z",
    fill: "#54220E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.391 169.65L205.557 133.843L226.843 154.684L190.391 169.65Z",
    fill: "#54220E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.282 190.939L154.515 227.715L133.789 206.31L169.282 190.939Z",
    fill: "#54220E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.242 169.65L133.789 154.752L155.005 133.843L170.242 169.65Z",
    fill: "#54220E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "translate(240 240)",
    fill: "#FF442A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M312.247 307.454C312.247 310.245 310.031 312.508 307.297 312.508H292.38C289.646 312.508 287.429 310.245 287.429 307.454V292.163C287.429 289.372 289.646 287.109 292.38 287.109H307.297C310.031 287.109 312.247 289.372 312.247 292.163V307.454ZM332.552 278.345V278.32H325.08C322.829 278.32 321.003 276.457 321.003 274.158V269.787H320.941C320.942 269.699 320.947 269.612 320.947 269.524C320.947 258.189 311.947 249.001 300.844 249.001C289.741 249.001 280.74 258.189 280.74 269.524C280.74 269.625 280.746 269.724 280.747 269.825V274.158C280.747 276.457 278.922 278.32 276.671 278.32H268.356C257.271 278.32 248.082 287.372 248.001 298.688C247.918 310.094 256.95 319.367 268.103 319.367V319.417H276.671C278.922 319.417 280.747 321.28 280.747 323.579V329.792C280.746 329.893 280.74 329.992 280.74 330.094C280.74 341.428 289.741 350.617 300.844 350.617C311.908 350.617 320.882 341.492 320.945 330.212H321.003V323.579C321.003 321.28 322.829 319.417 325.08 319.417H332.552V319.342C343.201 318.821 351.677 309.843 351.677 298.843C351.677 287.844 343.201 278.866 332.552 278.345Z",
    fill: "#54220E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "translate(0 240)",
    fill: "#54C2E4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1808 252.001L47.0469 286.342H74.2498L60.1808 252.001Z",
    fill: "#54220E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.806 299.306L74.7422 286.066V313.488L108.806 299.306Z",
    fill: "#54220E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12 299.306L46.0639 286.066V313.488L12 299.306Z",
    fill: "#54220E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5223 266.116L61.1484 281.036L80.3837 300.428L94.5223 266.116Z",
    fill: "#54220E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9062 266.114L59.2802 281.034L40.0449 300.426L25.9062 266.114Z",
    fill: "#54220E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2644 348.996L73.3983 314.655H46.1953L60.2644 348.996Z",
    fill: "#54220E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9062 334.889L59.2802 319.969L40.0449 300.577L25.9062 334.889Z",
    fill: "#54220E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5223 334.889L61.1484 319.969L80.3837 300.577L94.5223 334.889Z",
    fill: "#54220E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    transform: "translate(240)",
    fill: "#7D4C8C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M315.195 60.8607L350.689 45.7763V75.7773L315.195 60.8607Z",
    fill: "#F4EADA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M300.884 45.7754L286.414 8.99989H315.192L300.884 45.7754Z",
    fill: "#F4EADA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.723 75.7763L315.192 111.584H286.414L300.723 75.7763Z",
    fill: "#F4EADA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M286.412 60.6929L249 75.7773V45.7763L286.412 60.6929Z",
    fill: "#F4EADA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M310.391 70.9393L346.843 86.2404L325.627 107.715L310.391 70.9393Z",
    fill: "#F4EADA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M310.391 49.6465L325.557 13.8388L346.843 34.6803L310.391 49.6465Z",
    fill: "#F4EADA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M289.29 70.9393L274.523 107.715L253.797 86.31L289.29 70.9393Z",
    fill: "#F4EADA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M290.25 49.6465L253.797 34.7481L275.013 13.8388L290.25 49.6465Z",
    fill: "#F4EADA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    transform: "translate(360)",
    fill: "#E69408"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M575.563 151.263C586.859 170.621 580.156 195.374 560.591 206.55C541.027 217.726 516.009 211.093 504.714 191.736C493.418 172.378 500.121 147.625 519.686 136.449C539.25 125.273 564.268 131.906 575.563 151.263Z",
    fill: "#54220E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M384.487 151.263C373.191 170.621 379.895 195.374 399.459 206.55C419.024 217.726 444.041 211.093 455.337 191.736C466.633 172.378 459.929 147.625 440.365 136.449C420.8 125.273 395.783 131.906 384.487 151.263Z",
    fill: "#54220E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M515.446 48.2437C526.742 67.6011 520.039 92.354 500.474 103.53C480.91 114.706 455.892 108.074 444.596 88.7162C433.301 69.3581 440.004 44.606 459.569 33.4299C479.133 22.2539 504.151 28.8863 515.446 48.2437Z",
    fill: "#54220E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "banner-pattern_svg__clip0_3038_43545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "matrix(0 -1 1 0 360 360)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBannerPattern);
export default ForwardRef;